import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/filter/car.svg'


const _withScopeId = n => (_pushScopeId("data-v-359a677c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "editarUnicoSelecionado",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLongTitle"
}, "Editar produtos do veículo", -1))
const _hoisted_7 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_8 = { class: "card d-flex flex-row mb-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = {
  class: "w-100",
  style: {"margin":"0","padding":"1rem"}
}
const _hoisted_11 = {
  id: "listaDoCard",
  class: "p-3 d-flex flex-row justify-content-around align-items-center w-100"
}
const _hoisted_12 = {
  class: "d-flex flex-row w-100",
  id: "listaVeiculosDoModal"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "8",
  height: "20",
  viewBox: "0 0 8 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.931763 16.5714H1.71301V10.9286H0.931763C0.500278 10.9286 0.150513 10.5788 0.150513 10.1473V8.28125C0.150513 7.84977 0.500278 7.5 0.931763 7.5H5.30676C5.73825 7.5 6.08801 7.84977 6.08801 8.28125V16.5714H6.86926C7.30075 16.5714 7.65051 16.9212 7.65051 17.3527V19.2188C7.65051 19.6502 7.30075 20 6.86926 20H0.931763C0.500278 20 0.150513 19.6502 0.150513 19.2188V17.3527C0.150513 16.9212 0.500278 16.5714 0.931763 16.5714ZM3.90051 0C2.34719 0 1.08801 1.25918 1.08801 2.8125C1.08801 4.36582 2.34719 5.625 3.90051 5.625C5.45383 5.625 6.71301 4.36582 6.71301 2.8125C6.71301 1.25918 5.45379 0 3.90051 0Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Informações", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  class: "w-100",
  style: {"background":"#f9f9f9"}
}
const _hoisted_17 = {
  class: "nav nav-tabs rounded-2 d-flex flex-row",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "text-dark fs-4 p-4 border-0 nav-link active",
  id: "nav-lubrificantes-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#tab1",
  type: "button",
  role: "tab",
  "aria-controls": "tab1",
  "aria-selected": "true"
}, " Lubrificantes ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "text-dark fs-4 p-4 border-0 nav-link",
  id: "nav-todos-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#tab2",
  type: "button",
  role: "tab",
  "aria-controls": "tab2",
  "aria-selected": "false"
}, " Todos os filtros ", -1))
const _hoisted_20 = {
  class: "text-dark fs-4 p-4 border-0 nav-link",
  id: "nav-oleo-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#tab3",
  type: "button",
  role: "tab",
  "aria-controls": "tab3",
  "aria-selected": "false"
}
const _hoisted_21 = { class: "d-flex flex-row align-items-center" }
const _hoisted_22 = ["id"]
const _hoisted_23 = {
  class: "text-dark fs-4 p-4 border-0 nav-link",
  id: "nav-ar-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#tab4",
  type: "button",
  role: "tab",
  "aria-controls": "tab4",
  "aria-selected": "false"
}
const _hoisted_24 = { class: "d-flex flex-row align-items-center" }
const _hoisted_25 = ["id"]
const _hoisted_26 = {
  class: "text-dark fs-4 p-4 border-0 nav-link",
  id: "nav-combust-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#tab5",
  type: "button",
  role: "tab",
  "aria-controls": "tab5",
  "aria-selected": "false"
}
const _hoisted_27 = { class: "d-flex flex-row align-items-center" }
const _hoisted_28 = ["id"]
const _hoisted_29 = {
  class: "text-dark fs-4 p-4 border-0 nav-link",
  id: "nav-arcond-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#tab6",
  type: "button",
  role: "tab",
  "aria-controls": "tab6",
  "aria-selected": "false"
}
const _hoisted_30 = { class: "d-flex flex-row align-items-center" }
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "tab-content" }
const _hoisted_33 = {
  class: "tab-pane active",
  id: "tab1"
}
const _hoisted_34 = { class: "d-flex flex-column gap-4" }
const _hoisted_35 = { class: "d-flex flex-row w-100 gap-4" }
const _hoisted_36 = { class: "d-flex flex-column w-100" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lubrificante base ", -1))
const _hoisted_38 = { class: "d-flex flex-column w-100" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lubrificante Sae", -1))
const _hoisted_40 = { class: "d-flex flex-column w-100" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lubrificante Acea", -1))
const _hoisted_42 = { class: "d-flex flex-row w-100 gap-4" }
const _hoisted_43 = { class: "d-flex flex-column w-100" }
const _hoisted_44 = { class: "d-flex flex-column w-100" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lubrificante Api", -1))
const _hoisted_46 = { class: "d-flex flex-column w-100" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lubrificante iLsac", -1))
const _hoisted_48 = { class: "d-flex flex-column w-100" }
const _hoisted_49 = { class: "d-flex flex-column w-100" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lubrificante Oem", -1))
const _hoisted_51 = { class: "d-flex flex-column w-100" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carter com filtro", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btnSave d-flex w-100 justify-content-end",
  style: {"margin-top":"1.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("button", { type: "submit" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M19.3724 4.37237L15.6276 0.627634C15.2258 0.22577 14.6807 2.97177e-06 14.1124 0H2.14286C0.959375 0 0 0.959375 0 2.14286V17.8571C0 19.0406 0.959375 20 2.14286 20H17.8571C19.0406 20 20 19.0406 20 17.8571V5.88759C20 5.31927 19.7742 4.77423 19.3724 4.37237ZM10 17.1429C8.42205 17.1429 7.14286 15.8637 7.14286 14.2857C7.14286 12.7078 8.42205 11.4286 10 11.4286C11.5779 11.4286 12.8571 12.7078 12.8571 14.2857C12.8571 15.8637 11.5779 17.1429 10 17.1429ZM14.2857 3.54821V8.03571C14.2857 8.33156 14.0458 8.57143 13.75 8.57143H3.39286C3.09701 8.57143 2.85714 8.33156 2.85714 8.03571V3.39286C2.85714 3.09701 3.09701 2.85714 3.39286 2.85714H13.5946C13.7367 2.85714 13.873 2.91357 13.9734 3.01406L14.1288 3.16942C14.1785 3.21916 14.218 3.27821 14.2449 3.34321C14.2719 3.4082 14.2857 3.47786 14.2857 3.54821Z",
        fill: "#ED2B46"
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Salvar")
  ])
], -1))
const _hoisted_54 = {
  class: "tab-pane w-100",
  id: "tab2"
}
const _hoisted_55 = {
  class: "card d-flex flex-row overflow-auto w-100 gap-5 p-8",
  style: {"min-height":"22rem"},
  id: "scrollBarPrincipalAbas"
}
const _hoisted_56 = {
  class: "card rounded-2",
  style: {"min-width":"32rem","border":"0.5px solid #b5b5c3"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb-2 p-4 fs-3",
  style: {"border-bottom":"0.5px solid #b5b5c3"}
}, "Filtro de oleo", -1))
const _hoisted_58 = {
  class: "card rounded-2",
  style: {"min-width":"32rem","border":"0.5px solid #b5b5c3"}
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb-2 p-4 fs-3",
  style: {"border-bottom":"0.5px solid #b5b5c3"}
}, "Filtro de ar", -1))
const _hoisted_60 = {
  class: "card rounded-2",
  style: {"min-width":"32rem","border":"0.5px solid #b5b5c3"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb-2 p-4 fs-3",
  style: {"border-bottom":"0.5px solid #b5b5c3"}
}, "Filtro de combustivel", -1))
const _hoisted_62 = {
  class: "card rounded-2",
  style: {"min-width":"32rem","border":"0.5px solid #b5b5c3"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb-2 p-4 fs-3",
  style: {"border-bottom":"0.5px solid #b5b5c3"}
}, "Filtro de ar condicionado", -1))
const _hoisted_64 = {
  class: "tab-pane",
  id: "tab3"
}
const _hoisted_65 = {
  style: {"min-height":"22rem"},
  id: "scrolMobile",
  class: "card d-flex flex-row gap-3 p-7 w-100"
}
const _hoisted_66 = {
  class: "card me-5 p-4 justify-content-around",
  style: {"border":"0.5px solid #b5b5c3","width":"70%"},
  id: "cardEditUnique"
}
const _hoisted_67 = {
  key: 0,
  class: "ms-5 text-danger fs-6"
}
const _hoisted_68 = { class: "mb-3 mt-3" }
const _hoisted_69 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "",
  value: "Filtro de oleo",
  disabled: "",
  style: {"width":"100%","border-radius":"5px","border":"1px solid #b5b5c3","background":"white","height":"40px","font-size":"1.1rem","padding":"0.8rem"}
}, null, -1))
const _hoisted_71 = { class: "mb-3 mt-3" }
const _hoisted_72 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_73 = { class: "mb-3 mt-3" }
const _hoisted_74 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5714 8.35714H12.1429V1.92857C12.1429 1.13973 11.5031 0.5 10.7143 0.5H9.28571C8.49688 0.5 7.85714 1.13973 7.85714 1.92857V8.35714H1.42857C0.639732 8.35714 0 8.99688 0 9.78571V11.2143C0 12.0031 0.639732 12.6429 1.42857 12.6429H7.85714V19.0714C7.85714 19.8603 8.49688 20.5 9.28571 20.5H10.7143C11.5031 20.5 12.1429 19.8603 12.1429 19.0714V12.6429H18.5714C19.3603 12.6429 20 12.0031 20 11.2143V9.78571C20 8.99688 19.3603 8.35714 18.5714 8.35714Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"4px"} }, "Adicionar produto", -1))
const _hoisted_77 = [
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = {
  class: "tab-pane",
  id: "tab4"
}
const _hoisted_79 = {
  style: {"min-height":"22rem"},
  id: "scrolMobile",
  class: "card d-flex flex-row gap-3 p-7 w-100"
}
const _hoisted_80 = {
  class: "card me-5 p-4 justify-content-around",
  id: "cardEditUnique",
  style: {"border":"0.5px solid #b5b5c3","width":"70%"}
}
const _hoisted_81 = {
  key: 0,
  class: "ms-5 text-danger fs-6"
}
const _hoisted_82 = { class: "mb-3 mt-3" }
const _hoisted_83 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "",
  value: "Filtro de ar",
  disabled: "",
  style: {"width":"100%","border-radius":"5px","border":"1px solid #b5b5c3","background":"white","height":"40px","font-size":"1.1rem","padding":"0.8rem"}
}, null, -1))
const _hoisted_85 = { class: "mb-3 mt-3" }
const _hoisted_86 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_87 = { class: "mb-3 mt-3" }
const _hoisted_88 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5714 8.35714H12.1429V1.92857C12.1429 1.13973 11.5031 0.5 10.7143 0.5H9.28571C8.49688 0.5 7.85714 1.13973 7.85714 1.92857V8.35714H1.42857C0.639732 8.35714 0 8.99688 0 9.78571V11.2143C0 12.0031 0.639732 12.6429 1.42857 12.6429H7.85714V19.0714C7.85714 19.8603 8.49688 20.5 9.28571 20.5H10.7143C11.5031 20.5 12.1429 19.8603 12.1429 19.0714V12.6429H18.5714C19.3603 12.6429 20 12.0031 20 11.2143V9.78571C20 8.99688 19.3603 8.35714 18.5714 8.35714Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"4px"} }, "Adicionar produto", -1))
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = {
  class: "tab-pane",
  id: "tab5"
}
const _hoisted_93 = {
  style: {"min-height":"22rem"},
  id: "scrolMobile",
  class: "card d-flex flex-row gap-3 p-7 w-100"
}
const _hoisted_94 = {
  class: "card me-5 p-4 justify-content-around",
  id: "cardEditUnique",
  style: {"border":"0.5px solid #b5b5c3","width":"70%"}
}
const _hoisted_95 = {
  key: 0,
  class: "ms-5 text-danger fs-6"
}
const _hoisted_96 = { class: "mb-3 mt-3" }
const _hoisted_97 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "",
  value: "Filtro de combustivel",
  disabled: "",
  style: {"width":"100%","border-radius":"5px","border":"1px solid #b5b5c3","background":"white","height":"40px","font-size":"1.1rem","padding":"0.8rem"}
}, null, -1))
const _hoisted_99 = { class: "mb-3 mt-3" }
const _hoisted_100 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_101 = { class: "mb-3 mt-3" }
const _hoisted_102 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5714 8.35714H12.1429V1.92857C12.1429 1.13973 11.5031 0.5 10.7143 0.5H9.28571C8.49688 0.5 7.85714 1.13973 7.85714 1.92857V8.35714H1.42857C0.639732 8.35714 0 8.99688 0 9.78571V11.2143C0 12.0031 0.639732 12.6429 1.42857 12.6429H7.85714V19.0714C7.85714 19.8603 8.49688 20.5 9.28571 20.5H10.7143C11.5031 20.5 12.1429 19.8603 12.1429 19.0714V12.6429H18.5714C19.3603 12.6429 20 12.0031 20 11.2143V9.78571C20 8.99688 19.3603 8.35714 18.5714 8.35714Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"4px"} }, "Adicionar produto", -1))
const _hoisted_105 = [
  _hoisted_103,
  _hoisted_104
]
const _hoisted_106 = {
  class: "tab-pane",
  id: "tab6"
}
const _hoisted_107 = {
  style: {"min-height":"22rem"},
  id: "scrolMobile",
  class: "card d-flex flex-row gap-3 p-7 w-100"
}
const _hoisted_108 = {
  class: "card me-5 p-4 justify-content-around",
  id: "cardEditUnique",
  style: {"border":"0.5px solid #b5b5c3","width":"70%"}
}
const _hoisted_109 = {
  key: 0,
  class: "ms-5 text-danger fs-6"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none" }, "Fipe", -1))
const _hoisted_111 = ["value"]
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none" }, "Ano e combustivel", -1))
const _hoisted_113 = ["value"]
const _hoisted_114 = { class: "mb-3 mt-3" }
const _hoisted_115 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "",
  value: "Filtro de ar condicionado",
  disabled: "",
  style: {"width":"100%","border-radius":"5px","border":"1px solid #b5b5c3","background":"white","height":"40px","font-size":"1.1rem","padding":"0.8rem"}
}, null, -1))
const _hoisted_117 = { class: "mb-3 mt-3" }
const _hoisted_118 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_119 = { class: "mb-3 mt-3" }
const _hoisted_120 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5714 8.35714H12.1429V1.92857C12.1429 1.13973 11.5031 0.5 10.7143 0.5H9.28571C8.49688 0.5 7.85714 1.13973 7.85714 1.92857V8.35714H1.42857C0.639732 8.35714 0 8.99688 0 9.78571V11.2143C0 12.0031 0.639732 12.6429 1.42857 12.6429H7.85714V19.0714C7.85714 19.8603 8.49688 20.5 9.28571 20.5H10.7143C11.5031 20.5 12.1429 19.8603 12.1429 19.0714V12.6429H18.5714C19.3603 12.6429 20 12.0031 20 11.2143V9.78571C20 8.99688 19.3603 8.35714 18.5714 8.35714Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"4px"} }, "Adicionar produto", -1))
const _hoisted_123 = [
  _hoisted_121,
  _hoisted_122
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_card_de_filtros = _resolveComponent("card-de-filtros")!
  const _component_modal_info_veiculo = _resolveComponent("modal-info-veiculo")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openLub = true), _ctx.$emit('close')))
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.targetClickCar.car.marca) + " " + _toDisplayString(_ctx.targetClickCar.car.modelo), 1),
                    _createElementVNode("button", {
                      class: "btnInfoVeiculo",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('infoVeiculo')))
                    }, _hoisted_15)
                  ])
                ])
              ]),
              _createElementVNode("nav", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _hoisted_19,
                  _createElementVNode("button", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createTextVNode("Fil. de oleo "),
                      _createElementVNode("span", {
                        id: _ctx.filtroOleo.length ? 'tabOk' : 'tabRed'
                      }, _toDisplayString(_ctx.filtroOleo.length), 9, _hoisted_22)
                    ])
                  ]),
                  _createElementVNode("button", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createTextVNode("Fil. de ar "),
                      _createElementVNode("span", {
                        id: _ctx.filtroAr.length ? 'tabOk' : 'tabRed'
                      }, _toDisplayString(_ctx.filtroAr.length), 9, _hoisted_25)
                    ])
                  ]),
                  _createElementVNode("button", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                      _createTextVNode("Fil. de combust. "),
                      _createElementVNode("span", {
                        id: _ctx.filtroCombust.length ? 'tabOk' : 'tabRed'
                      }, _toDisplayString(_ctx.filtroCombust.length), 9, _hoisted_28)
                    ])
                  ]),
                  _createElementVNode("button", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createTextVNode("Fil. de ar cond. "),
                      _createElementVNode("span", {
                        id: _ctx.filtroArCond.length ? 'tabOk' : 'tabRed'
                      }, _toDisplayString(_ctx.filtroArCond.length), 9, _hoisted_31)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("form", {
                    onSubmit: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.attLub && _ctx.attLub(...args))),
                    style: {"min-height":"30.7rem"},
                    class: "d-flex flex-column card p-4"
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createVNode(_component_el_select, {
                            name: "",
                            id: "selectLub",
                            modelValue: _ctx.lubrificante_base_ref,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lubrificante_base_ref) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: _ctx.lubrificante_base_ref,
                                selected: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.lubrificante_base_ref), 1)
                                ]),
                                _: 1
                              }, 8, ["value"]),
                              _createVNode(_component_el_option, { value: "Mineral" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Mineral")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Semisintentico" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Semisintentico")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Sintetico" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Sintetico")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createVNode(_component_el_input, {
                            type: "text",
                            modelValue: _ctx.lubrificante_sae_ref,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lubrificante_sae_ref) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode(_component_el_input, {
                            type: "text",
                            modelValue: _ctx.lubrificante_acea_ref,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lubrificante_acea_ref) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _hoisted_45,
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: _ctx.lubrificante_api_ref,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lubrificante_api_ref) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: _ctx.lubrificante_ilsac_ref,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.lubrificante_ilsac_ref) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: _ctx.lubrificante_oem_ref,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lubrificante_oem_ref) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: _ctx.carter_com_filtro_ref,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.carter_com_filtro_ref) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _hoisted_53
                    ])
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode(_component_card_de_filtros, {
                        class: _normalizeClass(_ctx.filtroOleo.length ? '' : 'd-flex justify-content-center'),
                        style: {"height":"22rem"},
                        products: _ctx.filtroOleo,
                        onRemoveProduto: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removeProd($event)))
                      }, null, 8, ["class", "products"])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createVNode(_component_card_de_filtros, {
                        class: _normalizeClass(_ctx.filtroAr.length ? '' : 'd-flex justify-content-center'),
                        style: {"height":"22rem"},
                        products: _ctx.filtroAr,
                        onRemoveProduto: _cache[11] || (_cache[11] = ($event: any) => (_ctx.removeProd($event)))
                      }, null, 8, ["class", "products"])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_card_de_filtros, {
                        class: _normalizeClass(_ctx.filtroCombust.length ? '' : 'd-flex justify-content-center'),
                        style: {"height":"22rem"},
                        products: _ctx.filtroCombust,
                        onRemoveProduto: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeProd($event)))
                      }, null, 8, ["class", "products"])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createVNode(_component_card_de_filtros, {
                        class: _normalizeClass(_ctx.filtroArCond.length ? '' : 'd-flex justify-content-center'),
                        style: {"height":"22rem"},
                        products: _ctx.filtroArCond,
                        onRemoveProduto: _cache[13] || (_cache[13] = ($event: any) => (_ctx.removeProd($event)))
                      }, null, 8, ["class", "products"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("form", _hoisted_66, [
                      (_ctx.spanWarning == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_67, " Preencha todos os campos obrigatorios "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_68, [
                        _createTextVNode("Tipo do produto "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_69, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_70,
                      _createElementVNode("span", _hoisted_71, [
                        _createTextVNode("Marca "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_72, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_select, {
                        class: "",
                        modelValue: _ctx.marca,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.marca) = $event)),
                        placeholder: "Selecione um tipo para adicionar",
                        filterable: "",
                        clearable: "",
                        style: {"border-radius":"5px","border":"1px solid #b5b5c3","height":"40px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsMarcas?.data, (marca, key) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: key,
                              label: `${marca.nome}`,
                              value: `${marca.idMarca}`
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_73, [
                        _createTextVNode("Referencia "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_74, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        class: "mb-3",
                        name: "",
                        id: "selectModal",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referencia) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.referencia]
                      ]),
                      _createElementVNode("button", {
                        id: "btnAddProductModal",
                        style: {"display":"flex","justify-content":"center"},
                        class: "",
                        type: "button",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => {
                        _ctx.verifySelectValues(_ctx.e, '1');
                        _ctx.allList = true;
                      })
                      }, _hoisted_77)
                    ]),
                    _createVNode(_component_card_de_filtros, {
                      class: _normalizeClass(_ctx.filtroOleo.length ? '' : 'd-flex justify-content-center'),
                      style: {"border":"0.5px solid #b5b5c3","width":"40%"},
                      title: "Filtro de oleo",
                      products: _ctx.filtroOleo,
                      onRemoveProduto: _cache[17] || (_cache[17] = ($event: any) => (_ctx.removeProd($event)))
                    }, null, 8, ["class", "products"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("form", _hoisted_80, [
                      (_ctx.spanWarning == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_81, " Preencha todos os campos obrigatorios "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_82, [
                        _createTextVNode("Tipo do produto "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_83, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_84,
                      _createElementVNode("span", _hoisted_85, [
                        _createTextVNode("Marca "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_86, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.marca,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.marca) = $event)),
                        placeholder: "Selecione um tipo para adicionar",
                        filterable: "",
                        clearable: "",
                        style: {"border-radius":"5px","border":"1px solid #b5b5c3"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsMarcas?.data, (marca, key) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: key,
                              label: `${marca.nome}`,
                              value: `${marca.idMarca}`
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_87, [
                        _createTextVNode("Referencia "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_88, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        class: "mb-3",
                        name: "",
                        id: "selectModal",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.referencia) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.referencia]
                      ]),
                      _createElementVNode("button", {
                        id: "btnAddProductModal",
                        style: {"display":"flex","justify-content":"center"},
                        type: "button",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => {
                        _ctx.verifySelectValues(_ctx.e, '2');
                        _ctx.allList = true;
                      })
                      }, _hoisted_91)
                    ]),
                    _createVNode(_component_card_de_filtros, {
                      class: _normalizeClass(_ctx.filtroAr.length ? '' : 'd-flex justify-content-center'),
                      style: {"border":"0.5px solid #b5b5c3","width":"40%"},
                      title: "Filtro de ar",
                      products: _ctx.filtroAr,
                      onRemoveProduto: _cache[21] || (_cache[21] = ($event: any) => (_ctx.removeProd($event)))
                    }, null, 8, ["class", "products"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("form", _hoisted_94, [
                      (_ctx.spanWarning == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_95, " Preencha todos os campos obrigatorios "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_96, [
                        _createTextVNode("Tipo do produto "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_97, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_98,
                      _createElementVNode("span", _hoisted_99, [
                        _createTextVNode("Marca "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_100, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.marca,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.marca) = $event)),
                        placeholder: "Selecione um tipo para adicionar",
                        filterable: "",
                        clearable: "",
                        style: {"border-radius":"5px","border":"1px solid #b5b5c3"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsMarcas?.data, (marca, key) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: key,
                              label: `${marca.nome}`,
                              value: `${marca.idMarca}`
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_101, [
                        _createTextVNode("Referencia "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_102, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        class: "mb-3",
                        name: "",
                        id: "selectModal",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.referencia) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.referencia]
                      ]),
                      _createElementVNode("button", {
                        id: "btnAddProductModal",
                        style: {"display":"flex","justify-content":"center"},
                        type: "button",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => {
                        _ctx.verifySelectValues(_ctx.e, '4');
                        _ctx.allList = true;
                      })
                      }, _hoisted_105)
                    ]),
                    _createVNode(_component_card_de_filtros, {
                      class: _normalizeClass(_ctx.filtroCombust.length ? '' : 'd-flex justify-content-center'),
                      style: {"border":"0.5px solid #b5b5c3","width":"40%"},
                      title: "Filtro de combustivel",
                      products: _ctx.filtroCombust,
                      onRemoveProduto: _cache[25] || (_cache[25] = ($event: any) => (_ctx.removeProd($event)))
                    }, null, 8, ["class", "products"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("form", _hoisted_108, [
                      (_ctx.spanWarning == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_109, " Preencha todos os campos obrigatorios "))
                        : _createCommentVNode("", true),
                      _hoisted_110,
                      _createElementVNode("input", {
                        class: "d-none",
                        name: "",
                        id: "selectModal",
                        disabled: "",
                        value: _ctx.targetClickCar.car.fipe
                      }, null, 8, _hoisted_111),
                      _hoisted_112,
                      _createElementVNode("input", {
                        class: "d-none",
                        name: "",
                        id: "selectModal",
                        disabled: "",
                        value: _ctx.targetClickCar.car.ano
                      }, null, 8, _hoisted_113),
                      _createElementVNode("span", _hoisted_114, [
                        _createTextVNode("Tipo do produto "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_115, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_116,
                      _createElementVNode("span", _hoisted_117, [
                        _createTextVNode("Marca "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_118, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.marca,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.marca) = $event)),
                        placeholder: "Selecione um tipo para adicionar",
                        filterable: "",
                        clearable: "",
                        style: {"border-radius":"5px","border":"1px solid #b5b5c3"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsMarcas?.data, (marca, key) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: key,
                              label: `${marca.nome}`,
                              value: `${marca.idMarca}`
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_119, [
                        _createTextVNode("Referencia "),
                        (_ctx.spanWarning == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_120, " * "))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        class: "mb-3",
                        name: "",
                        id: "selectModal",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.referencia) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.referencia]
                      ]),
                      _createElementVNode("button", {
                        id: "btnAddProductModal",
                        style: {"display":"flex","justify-content":"center"},
                        type: "button",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => {
                        _ctx.verifySelectValues(_ctx.e, '3');
                        _ctx.allList = true;
                      })
                      }, _hoisted_123)
                    ]),
                    _createVNode(_component_card_de_filtros, {
                      class: _normalizeClass(_ctx.filtroArCond.length ? '' : 'd-flex justify-content-center'),
                      style: {"border":"0.5px solid #b5b5c3","width":"40%"},
                      title: "Filtro de ar condicionado",
                      products: _ctx.filtroArCond,
                      onRemoveProduto: _cache[29] || (_cache[29] = ($event: any) => (_ctx.removeProd($event)))
                    }, null, 8, ["class", "products"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading]
    ]),
    _createVNode(_component_modal_info_veiculo, {
      "target-click-car": _ctx.targetClickCar,
      onRefresh: _cache[30] || (_cache[30] = ($event: any) => (_ctx.refreshCarItems($event)))
    }, null, 8, ["target-click-car"])
  ], 64))
}